import React from 'react'
import { Switch, Route, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import * as UI from './components'
import { loadSharedPlan, loadSavedPlan, loadDraftPlan } from './store/actions'

const isProgress =
  (process.env.NODE_ENV === 'development' && window.location.port === '8787') ||
  window.location.origin === 'https://backoffice.capitalmind.in'

const isDraft = window.location.href.includes('draft=true')

class App extends React.Component {
  componentWillMount() {
    if (this.props.location.pathname.includes('shared')) {
      const id = this.props.location.pathname.split('/shared/')[1]
      this.props.loadSharedPlan(id)
      this.props.history.replace('/')
    }

    if (isProgress && !isDraft) {
      const id = window.CLIENT_ID === '{{pms_user_id}}' ? 159 : window.CLIENT_ID
      this.props.loadSavedPlan(id)
      this.props.history.replace('/')
    }

    if (isProgress && isDraft) {
      const id = window.CLIENT_ID === '{{pms_user_id}}' ? 159 : window.CLIENT_ID
      this.props.loadDraftPlan(id)
      this.props.history.replace('/')
    }
  }

  render() {
    return (
      <div className="app-container">
        <Route
          path="/"
          render={props => <UI.Header isProgress={isProgress} {...props} />}
        />
        <Route path="/:profile?/:edit?/:id?/new" component={UI.New} />
        <Route path="/:profile?/:edit?/:id?/clear" component={UI.Clear} />
        <Route path="/email" component={UI.Email} />
        <Route path="/share" component={UI.Share} />
        <Route path="/templates" component={UI.Templates} />
        {isProgress && <Route path="/save-draft" component={UI.SaveDraft} />}
        <main>
          <Route path="/" component={UI.Sidebar} />
          <Route path="/profile" component={UI.EditProfile} />
          <Route path="/edit/:id" component={UI.Edit} />
          <Route path="/edit/:id/delete" component={UI.Delete} />
          {this.props.noGoals ? (
            <UI.Empty />
          ) : (
            <section>
              <Route path="/" component={UI.Summary} />
              <Route path="/" component={UI.Allocations} />
              <Switch>
                <Route path="/edit/:id" component={UI.Goalpath} />
                <Route path="/" component={UI.Planpath} />
              </Switch>
            </section>
          )}
        </main>
      </div>
    )
  }
}

export default withRouter(
  connect(
    state => ({ noGoals: Object.values(state.goals).length === 0 }),
    { loadSharedPlan, loadSavedPlan, loadDraftPlan }
  )(App)
)



// WEBPACK FOOTER //
// ./src/app.js